import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { UpdateOrgUserApiArg } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_UPDATE_USER_SERVER } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUpdateUser = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [updateOrgUser, res] = esApi.endpoints.updateOrgUser.useMutation()

  const updateUser = useCallback(
    async (userId: number, data: UpdateOrgUserApiArg['body']) => {
      try {
        await updateOrgUser({
          orgId: orgId.toString(),
          userId: userId.toString(),
          body: data,
        }).unwrap()

        dispatch(
          createNotification({
            'update-user-success': {
              type: 'success',
              message: 'User updated successfully.',
            },
          }),
        )

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'update-user-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_UPDATE_USER_SERVER),
            },
          }),
        )

        return false
      }
    },
    [orgId, dispatch, updateOrgUser],
  )

  return [updateUser, res] as const
}
